export default function PreparationItemCategoryDirective() {
  return {
    template: require('./preparation-item-category.html'),
    scope: {
      auditId: '=',
      preparationItemCategory: '=',
      auditIsActive: '=',
      canEdit: '=',
      canDelete: '=',
    },
    controller: 'PreparationItemCategoryController',
    controllerAs: 'preparationItemCategoryVM',
    bindToController: true,
    replace: true
  };
}
